import fetch from 'utils/fetch';

export function orderAccAssignList(account,provider,psize,currentPage) {
    const data = {
        account,
        provider,
        psize,
        currentPage
    };
    return fetch({
        url: '/orderAccAssignList',
        method: 'get',
        params : data
    });
}

export function batchOrderAccAssign(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/batchOrderAccAssign',
        method: 'post',
        data
    });
}

export function batchDelAssign(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/batchDelAssign',
        method: 'post',
        data
    });
}

export function orderAccAssignDetail(accountStart, accountEnd,provider,account,receiverName, status, psize, currentPage) {
    const data = {
        accountStart,
        accountEnd,
        provider,
        account,
        receiverName,
        status,
        psize,
        currentPage
    };
    return fetch({
        url: '/orderAccAssignDetail',
        method: 'get',
        params : data
    });
}
export function removeOrderExcel(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/removeOrderExcel',
        method: 'post',
        data
    });
}





// WEBPACK FOOTER //
// ./src/api/orderAccAssign.js